import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "ItemSpecDocuments";

type ItemDocumentParams = {
  itemId: string;
  fileTypeFilter?: string;
  includeFileSize?: boolean;
};

export const getDocumentsForItem = async (params: ItemDocumentParams) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetItemLinkedDocuments`,
    undefined,
    params
  );
};
